import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getLocalidadesLista = async () => {
    const res = await getData('/localidades/localidades_select');
    return res
}

export const getLocalidadesPanel = async (searchTerm,searchProv,searchDepa,page, perPage) => {

    let queryParams = [];
    if (searchTerm) {
        queryParams.push(`loc_descripcion=${encodeURIComponent(searchTerm || '')}`);
    } 
    if (searchProv) {
        queryParams.push(`pcia_id=${encodeURIComponent(searchProv || '')}`);
    }
    if (searchProv) {
        queryParams.push(`depto_id=${encodeURIComponent(searchDepa || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    const res= await getData("/localidades", queryString);
    return res
};

export const getLocalidadById = async (id) => {
    const res = await getData(`/localidades/${id}`)
    return res
}

export const getXLocalidad = async (searchTerm) => {
    return await getData("/localidades", `?loc_descripcion=${searchTerm}`);
};

export const postLocalidad = async (body) => {
    const res = await postData('/localidades', body)
    return res
}

export const patchLocalidad = async (id, body) => {
    const res = await patchData(`/localidades/${id}`, body)
    return res
}

export const deleteLocalidad = async (id) => {
    const res = await deleteData(`/localidades/${id}`)
    return res
}

export const getAllProvincias = async () => {
    const res = await getData(`/provincias/provincias_select`)
    return res
}